<template>
  <b-container v-if="user && routeDataLoaded" class="profile-loanable" fluid>
    <template v-if="loanable">
      <vue-headful :title="fullTitle" />

      <h1 v-if="loanable.name">{{ loanable.name }}</h1>
      <h1 v-else>
        <em>{{ $t(`loanables.new.${loanable.type}`) }}</em>
      </h1>
    </template>

    <loanable-form :id="id" current-user-is-owner @submitted="submitted" />
  </b-container>
  <layout-loading v-else />
</template>

<script>
import LoanableForm from "@/components/Loanable/LoanableForm.vue";

import Authenticated from "@/mixins/Authenticated";
import DataRouteGuards from "@/mixins/DataRouteGuards";

import { capitalize } from "@/helpers/filters";

export default {
  name: "ProfileLoanable",
  components: {
    LoanableForm,
  },
  mixins: [Authenticated, DataRouteGuards],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    loanable() {
      return this.$store.state.loanables.item;
    },
    fullTitle() {
      const parts = [
        "LocoMotion",
        capitalize(this.$i18n.t("titles.profile")),
        capitalize(this.$i18n.tc("loanables.loanable", 2)),
      ];

      if (this.pageTitle) {
        parts.push(this.pageTitle);
      }

      return parts.reverse().join(" | ");
    },
    pageTitle() {
      return this.loanable?.name || capitalize(this.$i18n.tc("loanables.loanable", 1));
    },
  },
  methods: {
    async submitted() {
      this.$store.commit("loanable.search/invalidateCache");
      this.$store.dispatch("dashboard/loadLoanables");
    },
  },
};
</script>

<style lang="scss"></style>
